<ng-container *ngIf="organization$ | async as organization">
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="container-fluid justify-content-start">
      <a
        class="btn btn-light me-1 me-sm-3 d-none d-sm-inline"
        style="vertical-align: top"
        [routerLink]="['/']"
        title="Mina organisationer"
        ><span class="material-icons-outlined align-middle">hub</span></a
      >
      <button
        class="navbar-toggler me-1 px-1"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#homeNavigation"
        aria-controls="homeNavigation"
        aria-expanded="false"
        aria-label="Toggle navigation">
        <img
          *ngIf="organization.logoUrl"
          style="width: 40px"
          class=""
          [src]="organization.logoUrl"
          alt="{{ organization.name }}'s logo" />
        <!-- <span class="navbar-toggler-icon"></span> -->
      </button>
      <a class="navbar-brand d-flex align-items-center" [routerLink]="['/organization', organization.id]"
        ><img
          *ngIf="organization.logoUrl"
          style="height: 40px"
          class="mx-2 d-none d-lg-inline"
          [src]="organization.logoUrl"
          alt="{{ organization.name }}'s logo" />
        <div class="d-flex flex-column">
          <span class="fs-6">{{ organization.name }}</span>
          <span class="text-smallest d-block">{{ organization.parentName }}</span>
        </div></a
      >
      <div class="collapse navbar-collapse" id="homeNavigation">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0">
          <li class="nav-item py-2 py-sm-0 d-inline d-sm-none">
            <a class="nav-link" [routerLink]="['/']">
              <span class="material-icons-outlined align-middle d-inline d-lg-none d-xl-inline">hub</span>
              <span class="align-middle ms-1">Mina organisationer</span></a
            >
          </li>
          <li class="nav-item py-2 py-sm-0 me-2" *ngIf="!organization.removeDate">
            <a
              class="nav-link"
              data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse.show"
              [routerLinkActiveOptions]="{ exact: true }"
              [routerLink]="['/organization', organization.id]"
              routerLinkActive="active"
              ><span class="material-icons align-middle d-inline d-lg-none d-xl-inline">grid_view</span
              ><span class="align-middle ms-1">Översikt</span></a
            >
          </li>

          <li class="nav-item py-2 py-sm-0 me-2" *ngIf="!organization.isSupervisor && !organization.removeDate">
            <a
              class="nav-link position-relative"
              data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse.show"
              routerLinkActive="active"
              [routerLink]="['/organization', organization.id, 'current']"
              ><span class="material-icons align-middle d-inline d-lg-none d-xl-inline">today</span
              ><span class="align-middle ms-1">Pågående</span>
              <small
                class="d-none d-lg-inline position-absolute start-100 translate-middle badge rounded-pill bg-primary"
                *ngIf="currentActivities$ | async as currentActivities">
                {{ currentActivities.length }}
              </small>
            </a>
          </li>
          <li class="nav-item py-2 py-sm-0 me-2" *ngIf="organization.isSupervisor && !organization.removeDate">
            <a
              class="nav-link position-relative"
              data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse.show"
              routerLinkActive="active"
              [routerLink]="['/organization', organization.id, 'current']"
              ><span class="material-icons align-middle d-inline d-lg-none d-xl-inline">apps</span
              ><span class="align-middle ms-1">Aktivitetsmallar</span>
              <small
                class="d-none d-lg-inline position-absolute start-100 translate-middle badge rounded-pill bg-primary"
                *ngIf="currentActivities$ | async as currentActivities">
                {{ currentActivities.length }}
              </small>
            </a>
          </li>
          <li class="nav-item py-2 py-sm-0 me-2" *ngIf="!organization.isSupervisor && !organization.removeDate">
            <a
              class="nav-link position-relative"
              data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse.show"
              routerLinkActive="active"
              [routerLink]="['/organization', organization.id, 'archived']"
              ><span class="material-icons align-middle d-inline d-lg-none d-xl-inline">inventory_2</span
              ><span class="align-middle ms-1">Arkiverade</span>
            </a>
          </li>
          <li class="nav-item py-2 py-sm-0 me-2" *ngIf="!organization.isSupervisor && !organization.removeDate">
            <a
              class="nav-link position-relative"
              data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse.show"
              routerLinkActive="active"
              [routerLink]="['/organization', organization.id, 'members']"
              ><span class="material-icons align-middle d-inline d-lg-none d-xl-inline">people</span
              ><span class="align-middle ms-1">Personer</span>
              <small
                class="d-none d-lg-inline position-absolute start-100 translate-middle badge rounded-pill bg-secondary"
                *ngIf="members$ | async as members">
                {{ members.length }}
              </small></a
            >
          </li>

          <li class="nav-item py-2 py-sm-0 position-relative" *ngIf="!organization.removeDate">
            <a
              class="nav-link"
              data-bs-toggle="collapse"
              data-bs-target=".navbar-collapse.show"
              routerLinkActive="active"
              [routerLink]="['/organization', organization.id, 'settings']"
              ><span class="material-icons align-middle d-inline d-lg-none d-xl-inline">settings</span
              ><span class="align-middle ms-1">Inställningar</span>
              <small
                class="d-none d-lg-inline position-absolute start-100 translate-middle badge rounded-pill"
                *ngIf="
                  !organization.isSupervisor &&
                  (organization.paymentSettings.swish.number || organization.paymentSettings.swish?.recipients?.length === 0)
                ">
                <span class="material-icons text-warning">warning</span>
              </small>
            </a>
          </li>
          <li class="nav-item py-2 py-sm-0 d-inline d-lg-none">
            <app-support-icon [renderAsMenuOption]="true"></app-support-icon>
          </li>
        </ul>
        <app-support-icon class="me-3 d-none d-lg-inline" [renderAsMenuOption]="false"></app-support-icon>
        <app-account class="me-2"></app-account>
      </div>
    </div>
  </nav>
  <nav class="d-flex d-lg-none mt-2 nav shortcuts justify-content-center">
    <ul class="nav text-secondary pb-2 w-100 mx-2 justify-content-evenly">
      <li
        class="nav-item text-center"
        [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/organization', organization.id]"
        routerLinkActive="text-primary active border-bottom border-2 border-primary">
        <span class="material-icons align-middle d-block pt-2">grid_view</span>
        <span class="text-smallest text-uppercase">Översikt</span>
      </li>
      <li
        class="nav-item text-center"
        routerLinkActive="text-primary active border-bottom border-2 border-primary"
        [routerLink]="['/organization', organization.id, 'current']"
        *ngIf="!organization.isSupervisor">
        <span class="material-icons align-middle d-block pt-2">today</span>
        <span class="text-smallest text-uppercase">Pågående</span>
      </li>
      <li
        class="nav-item text-center"
        routerLinkActive="text-primary active border-bottom border-2 border-primary"
        [routerLink]="['/organization', organization.id, 'current']"
        *ngIf="organization.isSupervisor">
        <span class="material-icons align-middle d-block pt-2">apps</span>
        <span class="text-smallest text-uppercase">Aktivitetsmallar</span>
      </li>
      <li
        class="nav-item text-center"
        routerLinkActive="text-primary active border-bottom border-2 border-primary"
        [routerLink]="['/organization', organization.id, 'archived']"
        *ngIf="!organization.isSupervisor">
        <span class="material-icons align-middle d-block pt-2">inventory_2</span>
        <span class="text-smallest text-uppercase">Arkiverade</span>
      </li>
      <li
        class="nav-item text-center"
        routerLinkActive="text-primary active border-bottom border-2 border-primary"
        [routerLink]="['/organization', organization.id, 'members']"
        *ngIf="!organization.isSupervisor">
        <span class="material-icons align-middle d-block pt-2">people</span>
        <span class="text-smallest text-uppercase">Personer</span>
      </li>
      <li
        class="nav-item text-center position-relative"
        routerLinkActive="text-primary active border-bottom border-2 border-primary"
        [routerLink]="['/organization', organization.id, 'settings']">
        <span class="material-icons text-decoration-none align-middle d-block pt-2">settings</span>
        <span class="text-smallest text-uppercase">Inställningar</span>
        <small
          class="position-absolute top-0 start-50 badge rounded-pill"
          *ngIf="
            !organization.isSupervisor &&
            (organization.paymentSettings.swish.number || organization.paymentSettings.swish?.recipients?.length === 0)
          ">
          <span class="material-icons text-warning">warning</span>
        </small>
      </li>
    </ul>
  </nav>
</ng-container>
